import React, {useState} from "react";
import {useStore} from "../../../../../hooks/useStore";
import {useFetch} from "../../../../../hooks/useFetch";
import {Card, Table, Tooltip} from "antd";
import {
    courierBonusCampaignStatuses,
    courierBonusCampaignTypes
} from "../../../../../constants/constants";
import CampaignDetailViewer from "../campaignDetailViewer/CampaignDetailViewer";
import {CampaignModal} from "../campaignModal/CampaignModal";
const PAGE_SIZE = 20;
export const PoolHourlyBonusCampaigns = ({poolId, isTabOpened, recall, setRecall = () => {}}) => {
    const stores = useStore();
    const [filters, setFilters] = useState({
        poolId: poolId,
        subCompanyId: undefined,
        type: courierBonusCampaignTypes.HOURLY_FEE.value,
        status: undefined,
        startDate: undefined,
        endDate: undefined
    });
    const [page, setPage] = useState(1);

    const [loading, courierBonusCampaignsResults, setCourierBonusCampaignsResults] = useFetch({
        fetchFn: stores.courierBonusCampaignStore.listCourierBonusCampaigns.bind(null, {
            ...filters,
            skip: (page - 1) * PAGE_SIZE,
            limit: PAGE_SIZE
        }),
        dependencies: [filters, page, isTabOpened, recall],
        initialCall: isTabOpened,
        condition: !stores.meStore.checkRole("isCompanyUser") && isTabOpened && filters?.poolId
    });

    const expandedRowRender = courierBonusCampaign => {
        return (
            <div>
                <CampaignDetailViewer campaign={courierBonusCampaign} />
            </div>
        );
    };

    const columns = [
        {
            title: "Başlangıç Tarihi",
            dataIndex: "startDate",
            key: "startDate",
            width: 100,
            render: text => text && new Date(text).toLocaleDateString("tr-TR")
        },
        {
            title: "Bitiş Tarihi",
            dataIndex: "endDate",
            key: "endDate",
            width: 150,
            render: text => (text ? new Date(text).toLocaleDateString("tr-TR") : "")
        },
        {
            title: "Kampanya Adı",
            dataIndex: "name",
            key: "name",
            width: 100,
            ellipsis: {
                showTitle: false
            },
            render: text => <Tooltip title={text}>{text}</Tooltip>
        },
        {
            title: "Kampanya Tipi",
            dataIndex: "type",
            key: "type",
            width: 100,
            render: campaignType =>
                campaignType
                    ? Object.values(courierBonusCampaignTypes).find(
                          type => type.value === campaignType
                      )?.label
                    : ""
        },

        {
            title: "Durumu",
            dataIndex: "status",
            key: "status",
            width: 150,
            render: status =>
                status
                    ? Object.values(courierBonusCampaignStatuses).find(
                          cBCStatus => cBCStatus.value === status
                      )?.label
                    : ""
        },
        {
            title: "Aksiyon",
            dataIndex: "status",
            key: "status",
            width: 150,
            render: (text, campaign) => (
                <>
                    <CampaignModal
                        campaign={campaign}
                        refetch={() => setRecall(!recall)}
                        campaignType={campaign?.type}
                        mode="edit"
                        buttonLabel="Düzenle"
                        modalTitle="Kurye Bonus Kampanyası Düzenle"
                        okButtonLabel="Güncelle"
                    />
                </>
            )
        }
    ];

    return (
        <>
            <Card>
                <Table
                    loading={loading}
                    columns={columns}
                    size="small"
                    dataSource={courierBonusCampaignsResults?.rows || []}
                    rowKey="_id"
                    expandable={{
                        expandedRowRender,
                        expandedRowClassName: () =>
                            "expanded-row courier-bonus-campaign-expanded-row"
                    }}
                    scroll={{x: 500}}
                    pagination={{
                        total: courierBonusCampaignsResults?.dataCount || 0,
                        current: page,
                        hideOnSinglePage: true,
                        showSizeChanger: false,
                        pageSize: PAGE_SIZE,
                        onChange: page => {
                            setPage(page);
                        }
                    }}
                />
            </Card>
        </>
    );
};
